// Presentación compartida entre la pantalla del entrenador y el formulario de
// evaluación extraído (C1 de la Entrega 2). Vivían sueltas dentro de
// MonitorEvaluacionesPage; al sacar el formulario a componente propio las
// necesitan los dos, y duplicarlas sería empezar a que divergieran.
//
// NO se meten en `evaluationCatalog.ts` a propósito: ese fichero está duplicado
// byte a byte en `app/src/lib/` y cualquier añadido aquí rompería esa igualdad.

export function fmtDate(d: string | null): string {
  if (!d) return '—';
  return new Date(`${d}T00:00:00`).toLocaleDateString('es-ES', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
}

export function scoreColor(s: number): string {
  if (s >= 8) return '#4CAF50';
  if (s >= 6) return '#FFF200';
  if (s >= 4) return '#FF9800';
  return '#FF4444';
}
